import React from "react";
import { EntityType } from "../../PhotoManager/API/api";

interface HeaderSectionProps {
  onBack: () => void;
  selfieImageFromUrl: string | null;
  totalCount: number;
  entityType: EntityType;
  entityName: string;
  action?: React.ReactNode;
}

const getEntityTypeLabel = (entityType: EntityType): string => {
  switch (entityType) {
    case "tag":
      return "Tag";
    case "person":
      return "Person";
    case "group":
      return "Group";
    case "event":
      return "Event";
    case "album":
      return "Album";
    case "folder":
      return "Folder";
    default:
      return "";
  }
};

const HeaderSection: React.FC<HeaderSectionProps> = ({
  onBack,
  selfieImageFromUrl,
  totalCount,
  entityType,
  entityName,
  action
}) => {
  return (
    <>
      <button
        type="button"
        className="filtered-back-button"
        onClick={onBack}
        aria-label="Back"
      >
        <i className="fa fa-arrow-left"></i>
        Back
      </button>

      {selfieImageFromUrl && (
        <div className="selfie-search-preview">
          <img
            src={selfieImageFromUrl}
            alt="Selfie search"
            className="selfie-preview-image"
          />
          <div className="selfie-preview-text">
            <strong>{totalCount} photos</strong> matches the{" "}
            <strong>selfie</strong>
          </div>
          <button
            type="button"
            className="selfie-preview-close"
            onClick={onBack}
            aria-label="Clear selfie search"
          >
            ×
          </button>
          {action && <div className="filtered-header-action">{action}</div>}
        </div>
      )}

      {!selfieImageFromUrl && (
        <div className="filtered-header-section">
          <span className="filtered-entity-label">{getEntityTypeLabel(entityType)}:</span>
          <span className="filtered-entity-name">{entityName}</span>
          {action && <div className="filtered-header-action">{action}</div>}
        </div>
      )}
    </>
  );
};

export default HeaderSection;
